import massificationMock from "@/mock/massification.json";
import {actualite} from "@/types/actualite";

import {getDataMock} from "./_callApi";

export async function getMassification(): Promise<actualite[]> {
  if (getDataMock()) {
    const massification: actualite[] = massificationMock;
    return massification;
  } else {
    const massification: actualite[] = massificationMock;
    return massification;
  }
}
